import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
} from '@mui/material'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import Row from './Row'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'
import Import from './Import'

const Table = ({ monthYear, open, setOpen, data, isLoading, refetch }) => {
  return (
    <Box>
      {data.length || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>View</TableCell>
                  <TableCell>Send</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Delete</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={6} />
                ) : (
                  data.map((row) => <Row data={row} key={row._id} refetch={refetch} />)
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
        </>
      ) : (
        <ErrorMessage empty />
      )}
      <Import open={open} setOpen={setOpen} refetch={refetch} />
    </Box>
  )
}

export default Table
